module.exports = __webpack_public_path__ + "static/img/1.d293ac7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/1.png
// module id = GhKf
// module chunks = 0